"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceComparatorService = void 0;
var R = require("ramda");
var ResourceComparatorService = /** @class */ (function () {
    function ResourceComparatorService() {
    }
    ResourceComparatorService.prototype.isPatchEqualTo = function (patch, fullResource) {
        return this.deepCompare(fullResource, patch);
    };
    ResourceComparatorService.prototype.isResourceEqualTo = function (referenceResource, existingResource) {
        var existingMatchesReference = this.deepCompare(existingResource, referenceResource);
        var referenceMatchesExisting = this.deepCompare(referenceResource, existingResource);
        return existingMatchesReference && referenceMatchesExisting;
    };
    ResourceComparatorService.prototype.deepCompare = function (fullResource, patch) {
        var _this = this;
        var attributesToBeCompared = this.findAttributeToCompare(fullResource, patch);
        var relationshipsToBeCompared = this.findRelationshipsToCompare(fullResource, patch);
        var metaPropertiesToBeCompared = R.keys(patch.meta);
        var idResult = R.eqProps('id', patch, fullResource);
        var typeResult = R.eqProps('type', patch, fullResource);
        var attributeResults = attributesToBeCompared.map(function (property) { return _this.compareAttribute(property, fullResource, patch); });
        var relationshipsResults = relationshipsToBeCompared.map(function (property) { return _this.compareRelationship(property, fullResource, patch); });
        var metaResults = metaPropertiesToBeCompared.map(function (property) { return _this.compareMetaProperty(property, fullResource, patch); });
        return !__spreadArrays([idResult, typeResult], attributeResults, relationshipsResults, metaResults).includes(false);
    };
    ResourceComparatorService.prototype.findAttributeToCompare = function (fullResource, patch) {
        var _this = this;
        return R.keys(patch.attributes).filter(function (property) { return !_this.attributeIsNullInPatchAndUndefinedOnResource(property, fullResource, patch); });
    };
    ResourceComparatorService.prototype.attributeIsNullInPatchAndUndefinedOnResource = function (property, fullResource, patch) {
        var _a, _b;
        return ((_a = patch.attributes) === null || _a === void 0 ? void 0 : _a[property]) === null && ((_b = fullResource.attributes) === null || _b === void 0 ? void 0 : _b[property]) === undefined;
    };
    ResourceComparatorService.prototype.findRelationshipsToCompare = function (fullResource, patch) {
        var _this = this;
        return R.keys(patch.relationships).filter(function (property) { return !_this.relationshipIsNullInPatchAndUndefinedOnResource(property, fullResource, patch); });
    };
    ResourceComparatorService.prototype.relationshipIsNullInPatchAndUndefinedOnResource = function (property, fullResource, patch) {
        var _a, _b;
        return ((_a = patch.relationships) === null || _a === void 0 ? void 0 : _a[property]) === null && ((_b = fullResource.relationships) === null || _b === void 0 ? void 0 : _b[property]) === undefined;
    };
    ResourceComparatorService.prototype.compareAttribute = function (attributeName, fullResource, patch) {
        return R.eqProps(attributeName, patch.attributes, fullResource.attributes);
    };
    ResourceComparatorService.prototype.compareRelationship = function (relationshipName, fullResource, patch) {
        var _a, _b;
        var relationshipOnPatch = ((_a = patch.relationships) === null || _a === void 0 ? void 0 : _a[relationshipName]) ? R.omit(['links'], patch.relationships[relationshipName]) : undefined;
        var relationshipOnFullResource = ((_b = fullResource.relationships) === null || _b === void 0 ? void 0 : _b[relationshipName]) ? R.omit(['links'], fullResource.relationships[relationshipName])
            : undefined;
        return R.equals(relationshipOnPatch, relationshipOnFullResource);
    };
    ResourceComparatorService.prototype.compareMetaProperty = function (propertyName, fullResource, patch) {
        return R.eqProps(propertyName, patch.meta, fullResource.meta);
    };
    return ResourceComparatorService;
}());
exports.ResourceComparatorService = ResourceComparatorService;
//# sourceMappingURL=resource-comparator.service.js.map